import API from "@/models/API";

export default class PaymentMethods {
    constructor(item = {}) {
        this.name = item.name || ''
        this.store_payment_method_id = item.store_payment_method_id || null;
        this.system_payment_method_id = item.system_payment_method_id || null;
        this.credentials = item.credentials || {};
    }

    static getCompanyPaymentMethods = () =>
        API.get(`/companies/${localStorage.getItem("storeId")}/subscriptions/payment-methods`);

    static getSystemPaymentMethods = () =>
        API.get(`/companies/${localStorage.getItem("storeId")}/subscriptions/system-payment-methods`);

    static getPaymentMethodProfile = (id) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/subscriptions/payment-methods/${id}`);

    static create = item =>
        API.post(
            `/companies/${localStorage.getItem("storeId")}/subscriptions/payment-method`,
            item
        );

    static update = (item,id) =>
        API.put(
            `/companies/${localStorage.getItem("storeId")}/subscriptions/payment-methods/${id}`,
            item
        );

    static delete = (id) =>
        API.delete(`/companies/${localStorage.getItem("storeId")}/subscriptions/payment-methods/${id}`);

}
